<template>
  <div>
    <vx-card>
      <div class="flex items-center gap-3 font-medium">
        <p style="width: 114px">연도</p>
        <vs-select v-model="targetYear" autocomplete @change="loadData">
          <vs-select-item :key="year" v-for="year in yearList" :value="year" :text="year" />
        </vs-select>
      </div>
    </vx-card>

    <div class="flex items-center justify-end my-4">
      <vs-button type="border" color="secondary" @click="excelDownWithHtml('riskproposal')">Excel 다운로드</vs-button>
    </div>

    <table id="riskproposal">
      <colgroup>
        <col width="21%"/>
        <col width="15%"/>
        <col width="15%"/>
        <col width="9%"/>
        <col width="31%"/>
        <col width="9%"/>
      </colgroup>
      <thead>
      <tr>
        <th colspan="6" style="text-align: start; padding: 10px; font-weight: 500;">위험성 수준이 ‘보통(4~9)’ 이상으로서 개선 미완료인 경우 :
          <span style="font-weight: 700;">{{ countRiskItems() }}건</span>
        </th>
      </tr>
      <tr>
        <th rowspan="2">사업장명</th>
        <th colspan="3">개선 전</th>
        <th colspan="2">개선 후</th>
      </tr>
      <tr>
        <th>유해·위험요인</th>
        <th>현재 안전보건조치</th>
        <th>위험도</th>
        <th>위험감소대책</th>
        <th>위험도</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in riskList">
        <tr>
          <td class="value-td">{{ item.field.field_name }}</td>
          <td class="value-td">{{ item.harmfulRisk }}</td>
          <td class="value-td">{{ item.before.current }}</td>
          <td class="value-td">{{ item.before.rate }}</td>
          <td class="value-td">{{ item.after.improved || '위험감소대책을 입력 안했음'}}</td>
          <td class="value-td">{{ item.after.rate===0? '-':item.after.rate }}</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";
import HttpRequest from "@/util/HttpRequest";
import XLSX from "xlsx";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      targetYear: new Date().getFullYear().toString(), // 현재 년도로 초기화
      yearList: this.generateYearList(2023, new Date().getFullYear()), // 2023년부터 현재 년도까지
      riskList: [],
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    generateYearList(start, end) {
      const result = [];
      for (let year = start; year <= end; year++) {
        result.push(year.toString());
      }
      return result;
    },
    excelDownWithHtml(tableName) {
      let wb = XLSX.utils.table_to_book(document.getElementById(tableName), { sheet: "유해위험요인 개선 현황", raw: true });
      XLSX.writeFile(wb, "유해위험요인 개선 현황.xlsx");
    },
    loadData() {
      const params = {
        params: {
          targetYear: this.targetYear,
          projectId: this.projectId
        }
      }
      new Promise((resolve, reject) => {
        HttpRequest.get(`/api/v1/summary/post/161/detail`, params)
          .then(response => {
            this.riskList = response
          }).catch(err => reject(err))
      })
    },
    // 위험수준 4이상에 개선 미완료 카운트
    countRiskItems() {
      return this.riskList.filter(item => {
        return (item.before.rate >= 4) && ((item.after.rate >= 4) || (item.after.rate === 0));
      }).length;
    }
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th {
    text-align: center;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    background: #f9f9f9;
    border: 1px solid #cdcdcd;
    padding: 10px 0;

    &:first-child {
      padding: 0;
    }
  }

  td {
    border: 1px solid #cdcdcd;
    padding: 7px;
  }
}

.check::v-deep {
  justify-content: center !important;
  span {
    margin: 0;
  }
}

.head-td {
  text-align: center;
  background-color: #f9f9f9;
}
.total-td {
  text-align: center;
  background-color: #FFF6E6;
}
.value-td {
  text-align: center;
  background-color: #ffffff;
}
</style>
